// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"jump-off"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9.50977 4.00195L9.49977 4.00195M9.49977 4.00195L9.00074 4.00195L8.99974 4.00095L9.49977 4.00195ZM19.225 4.775L14.5 9.5M20 14.5V14.999L20.001 15L20 14.5ZM20 14.5V14.49M14 4L20 4V10M4 4L4 20H20L4 4ZM11.4984 12.5019L11.5011 12.4992L11.5039 12.5019L11.5011 12.5047L11.4984 12.5019Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M21 21L3 3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-jump-off')
export default class JumpOffIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'jump-off',
    }
  }
}
